import classes from "./Cell.module.scss";
import { forwardRef } from "react";
import clsx from "clsx";
import { motion } from "framer-motion";
import { NAME_SOUND_HOVER, useGameSounds } from "@educaplay/core";


export const Cell = forwardRef(function Cell(props, ref) {
    const { number, id, className, wordID, isFirst, state, renderID, ...inputProps } = props;
    const [row, column] = id.split("-").map(Number);
    const gameSounds = useGameSounds();
    const actualizedKey = renderID + (state === false ? 1 : 0);
    const isIntersection = document.querySelectorAll(`[id="${id}"]`).length > 1;

    return (
        <motion.div
            data-animate-id="cell"
            id={id}
            initial={{ opacity: 0 }}
            className={classes.cell}
            style={{ gridRow: row + 1, gridColumn: column + 1, zIndex: isIntersection && isFirst ? 5 : "" }}
            onMouseEnter={() => { gameSounds.play(NAME_SOUND_HOVER) }}
        >
            <input
                aria-label="inserte letra"
                key={actualizedKey}
                ref={ref}
                className={clsx(classes.inputcell, className)}
                data-animate-wordid={state ? null : wordID}
                type="text"
                autoCapitalize="off"
                autoCorrect="off"
                autoComplete="off"
                inputMode="text"
                {...inputProps}
            />
            {number && <span className={classes.number}>{number}</span>}
        </motion.div>
    );
})

